<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>账号管理</span>
          <el-button type="primary" @click="openCreate" style="float: right">创建账号</el-button>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="用户名">
          <el-input v-model="searchForm.username" placeholder="请输入用户名" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="searchForm.roleId" placeholder="请选择角色">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="role in roleList" :key="role.id" :label="role.description || role.name" :value="role.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="userList" style="width: 100%" @row-dblclick="row => handleEdit(row)">
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="role" label="角色">
          <template slot-scope="scope">
            <el-tag :type="getRoleType(scope.row.role)">
              {{ getRoleName(scope.row.role) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="id" label="账号ID" width="80"></el-table-column>
        <el-table-column label="操作" width="560">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="info" size="small" @click="openPermDialog(scope.row)">出库权限</el-button>
            <el-button type="warning" size="small" plain @click="handleResetPassword(scope.row)">重置密码</el-button>
            <el-button v-if="scope.row.status === 1" type="warning" size="small" @click="handleFreeze(scope.row.id)">冻结</el-button>
            <el-button v-else type="success" size="small" @click="handleUnfreeze(scope.row.id)">解冻</el-button>
            <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-4">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 创建/编辑账号对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="880px"
               :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" show-password autocomplete="new-password" v-if="!form.id"></el-input>
          <el-input v-model="form.password" type="password" placeholder="点右侧眼睛查看；改了点保存即覆盖" show-password autocomplete="new-password" v-else></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="form.roleId" placeholder="请选择角色">
            <el-option v-for="role in roleList" :key="role.id" :label="role.description || role.name" :value="role.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 出库权限对话框 -->
    <el-dialog :title="permDialogTitle" :visible.sync="permDialogVisible" width="880px"
               :close-on-click-modal="false" :close-on-press-escape="false">
      <p class="hint">勾选该账号在小程序可提交的出库方式。超级管理员不受此限制（默认全量放行）。</p>
      <el-checkbox-group v-model="selectedCodes">
        <el-checkbox v-for="t in outboundTypes" :key="t.code" :label="t.code" border style="margin: 6px 8px 6px 0">
          {{ t.name }}
        </el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="permDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingPerm" @click="savePerms">保存</el-button>
      </div>
    </el-dialog>

    <!-- 功能权限对话框（按账号自由勾选操作按钮权限） -->
    <el-dialog :title="funcDialogTitle" :visible.sync="funcDialogVisible" width="720px"
               :close-on-click-modal="false" :close-on-press-escape="false">
      <p class="hint">勾选该账号在后台可执行的操作。超级管理员不受此限制（默认全量放行）。</p>
      <div v-for="g in funcGroups" :key="g.module" style="margin-bottom:14px;">
        <div style="font-weight:600;color:#303133;margin-bottom:6px;border-left:3px solid #409EFF;padding-left:8px;">{{ g.module }}</div>
        <el-checkbox-group v-model="funcSelected">
          <el-checkbox v-for="it in g.items" :key="it.code" :label="it.code" border style="margin: 6px 8px 6px 0">
            {{ it.name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="funcDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="savingFunc" @click="saveFunc">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userApi, roleApi } from '../api/api'

export default {
  data() {
    return {
      userList: [],
      roleList: [],
      searchForm: {
        username: '',
        roleId: '',
        status: ''
      },
      dialogVisible: false,
      dialogTitle: '创建账号',
      form: {
        id: '',
        username: '',
        password: '',
        name: '',
        phone: '',
        roleId: '',
        status: 1,
        remark: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        roleId: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 出库权限
      permDialogVisible: false,
      permDialogTitle: '',
      permCurrentUserId: null,
      outboundTypes: [],
      selectedCodes: [],
      savingPerm: false,
      // 功能权限
      funcDialogVisible: false,
      funcDialogTitle: '',
      funcCurrentUserId: null,
      funcGroups: [],      // [{module, items:[{code,name}]}]
      funcSelected: [],
      savingFunc: false
    }
  },
  mounted() {
    this.getUserList()
    this.getRoleList()
    this.loadOutboundTypes()
    this.loadFuncPermissions()
  },
  methods: {
    getUserList() {
      userApi.getUserPage(this.currentPage, this.pageSize, this.searchForm.username, this.searchForm.roleId, this.searchForm.status).then(res => {
        this.userList = res.data.records || []
        this.total = res.data.total || this.userList.length
      })
    },
    getRoleList() {
      roleApi.getRoleList().then(res => {
        this.roleList = res.data || []
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.getUserList()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.getUserList()
    },
    handleCurrentChange(current) {
      this.currentPage = current
      this.getUserList()
    },
    openCreate() {
      // 重置 form；密码字段默认 123456，admin 不改就用默认密码
      this.form = {
        id: '', username: '', password: '123456', name: '', phone: '',
        roleId: '', status: 1, remark: ''
      }
      this.dialogTitle = '创建账号'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.clearValidate) this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      // 密码字段预填该账号当前真实密码（后端 AES 解密后返回的 decryptedPassword）
      // 解密失败（旧 bcrypt 残留 / 迁移失败等）回退默认 123456
      this.form = { ...row, password: row.decryptedPassword || '123456' }
      this.dialogTitle = '编辑账号'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.clearValidate) this.$refs.form.clearValidate()
      })
    },
    handleResetPassword(row) {
      this.$confirm('确定把 ' + (row.name || row.username) + ' 的密码重置为默认 123456 吗？', '重置密码', {
        confirmButtonText: '确定重置',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const body = {
          id: row.id, username: row.username, name: row.name, phone: row.phone,
          roleId: row.roleId, status: row.status, password: '123456'
        }
        userApi.updateUser(body).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已重置为默认密码 123456')
            this.getUserList()
          } else {
            this.$message.error((res.data && res.data.message) || '重置失败')
          }
        })
      }).catch(() => {})
    },
    handleFreeze(id) {
      this.$confirm('确定要冻结该账号吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userApi.updateStatus(id, 0).then(res => {
          if (res.data.success) {
            this.$message.success('冻结成功')
            this.getUserList()
          } else {
            this.$message.error('冻结失败')
          }
        })
      }).catch(() => {
        this.$message.info('已取消冻结')
      })
    },
    handleUnfreeze(id) {
      this.$confirm('确定要解冻该账号吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userApi.updateStatus(id, 1).then(res => {
          if (res.data.success) {
            this.$message.success('解冻成功')
            this.getUserList()
          } else {
            this.$message.error('解冻失败')
          }
        })
      }).catch(() => {
        this.$message.info('已取消解冻')
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除该账号吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userApi.deleteUser(id).then(res => {
          if (res.data.success) {
            this.$message.success('删除成功')
            this.getUserList()
          } else {
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            userApi.updateUser(this.form).then(res => {
              if (res.data.success) {
                this.$message.success('更新成功')
                this.dialogVisible = false
                this.getUserList()
              } else {
                this.$message.error(res.data.message || '更新失败')
              }
            })
          } else {
            userApi.addUser(this.form).then(res => {
              if (res.data.success) {
                this.$message.success('创建成功')
                this.dialogVisible = false
                this.getUserList()
                // 重置表单
                this.form = {
                  id: '',
                  username: '',
                  password: '',
                  name: '',
                  phone: '',
                  roleId: '',
                  status: 1,
                  remark: ''
                }
              } else {
                this.$message.error(res.data.message || '创建失败')
              }
            })
          }
        }
      })
    },
    loadOutboundTypes() {
      userApi.getOutboundTypes().then(res => { this.outboundTypes = res.data || [] })
    },
    loadFuncPermissions() {
      userApi.getFuncPermissions().then(res => {
        const list = res.data || []
        const trialCodes = [
          { code: 'func:trial:consumption', name: '标记试用消费情况', module: '产品试用' },
          { code: 'func:trial:unlock-limit', name: '解除产品试用上限限制', module: '产品试用' }
        ]
        trialCodes.forEach(tc => {
          if (!list.some(x => x.code === tc.code)) {
            list.push(tc)
          }
        })
        const byModule = []
        const idx = {}
        list.forEach(it => {
          if (idx[it.module] == null) { idx[it.module] = byModule.length; byModule.push({ module: it.module, items: [] }) }
          byModule[idx[it.module]].items.push({ code: it.code, name: it.name })
        })
        this.funcGroups = byModule
      })
    },
    openFuncDialog(row) {
      this.funcCurrentUserId = row.id
      this.funcDialogTitle = `功能权限 — ${row.name || row.username}`
      userApi.getFuncCodes(row.id).then(res => { this.funcSelected = res.data || [] })
      this.funcDialogVisible = true
    },
    saveFunc() {
      if (!this.funcCurrentUserId) return
      this.savingFunc = true
      userApi.saveFuncCodes(this.funcCurrentUserId, this.funcSelected).then(res => {
        if (res.data && res.data.success !== false) {
          this.$message.success('保存成功')
          this.funcDialogVisible = false
        } else {
          this.$message.error(res.data.message || '保存失败')
        }
      }).finally(() => { this.savingFunc = false })
    },
    openPermDialog(row) {
      this.permCurrentUserId = row.id
      this.permDialogTitle = `出库权限 — ${row.name || row.username}`
      userApi.getOutboundCodes(row.id).then(res => { this.selectedCodes = res.data || [] })
      this.permDialogVisible = true
    },
    savePerms() {
      if (!this.permCurrentUserId) return
      this.savingPerm = true
      userApi.saveOutboundCodes(this.permCurrentUserId, this.selectedCodes).then(res => {
        if (res.data && res.data.success !== false) {
          this.$message.success('保存成功')
          this.permDialogVisible = false
        } else {
          this.$message.error(res.data.message || '保存失败')
        }
      }).finally(() => { this.savingPerm = false })
    },
    getRoleType(roleName) {
      switch (roleName) {
        case 'super_admin': return 'danger'
        case 'admin': return 'warning'
        case 'salesman': return 'success'
        default: return 'info'
      }
    },
    getRoleName(roleName) {
      const map = { 'super_admin': '超级管理员', 'admin': '行政管理员', 'salesman': '业务员' }
      return map[roleName] || roleName
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; }
.clearfix { display: flex; align-items: center; justify-content: space-between; }
.hint { color: #606266; font-size: 13px; margin-bottom: 12px; }
</style>
